import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import {
  GetERP_SendGoodsByPage,
  ERP_AuditSendGoods,
  GetSendGoodsAuditStatistics
} from '@api/sendGoodsApi';
import {
  GetOrderFinanceAuditByPage,
  ERP_AuditOrder,
  GetERP_OrderById
} from '@api/orderApi';
import NProgress from 'nprogress';
import {
  MAP_LIST
} from '$http';
import $http from '$http';
import deviceView from './components/deviceView/index.vue'

export default {
  mixins: [services],
  components: {
    deviceView
  },
  data: function () {
    return {
      loading: false,
      lists: [],
      pageIndex: 1,
      pageSize: 10,
      totalSize: '',
      pageSizes: [10, 20, 50],
      query: this.getQuery(),
      TipdialogVisible: false,
    }
  },
  methods: {
    getQuery() {
      return cloneDeep({
        C_Name: "",
        Tel: "",
        Customer: "",
        CustomerId: "",
        min: "",
        max: "",
      });
    },
    tipBtn() {
      this.TipdialogVisible = true
    },
    //搜素查询
    onQuerySubmit() {
      this.pageIndex = 1;
      this.getList();
    },

    //重置
    onQueryClean() {
      this.query = this.getQuery();
      this.getList();
    },
    //查看设备情况
    handleView(index, row) {
      this.$refs.refDeviceView.show({
        agentId: row.Id
      })
    },
    //导出
    download() {
      this.$confirm('确认导出吗？', '提示', {}).then(() => {
        this.getList();
        var params = {
          Sid: this.$store.state.sysSid,
          Session: this.$store.state.sysSession,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        };
        for (let item in this.query) {
          let value = this.query[item];
          if (value != '') {
            params[item] = value;
          }
        }
        util.exportToFileV2("api/Agent/Agent_HiBookListExport", params, this);
      });
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
  },
  watch: {
    '$route' (to, from) {
      this.showOrHideAuditBtn();
    }
  },
  created() {
    this.getList();
  }

}


// WEBPACK FOOTER //
// ./src/pages/Agent/hiPackage/vm.js